export default function max(enumerable, selector) {
    const values = enumerable.select(selector);
    return Math.max(...values);
}
